export const formatSpiideoChipLabel = (value) => {
    if (null == value || '' === value) {
        return value;
    }

    const text = String(value).replaceAll('_', ' ').toLowerCase();

    return text.charAt(0).toUpperCase() + text.slice(1);
};

export const getSpiideoChipColor = (value) => {
    const normalized = String(value ?? '').toLowerCase();

    if ('deleted' === normalized) {
        return 'default';
    }

    if ('done' === normalized || 'success' === normalized) {
        return 'success';
    }

    if ('failed' === normalized) {
        return 'error';
    }

    if ('blocked' === normalized || 'conflict' === normalized) {
        return 'warning';
    }

    return 'default';
};

const DELETED_CHIP_SX = {
    bgcolor: '#000',
    color: '#fff',
    '& .MuiChip-label': {
        color: '#fff',
    },
};

export const getSpiideoChipProps = (value) => {
    if ('deleted' === String(value ?? '').toLowerCase()) {
        return {
            color: 'default',
            sx: DELETED_CHIP_SX,
        };
    }

    return {
        color: getSpiideoChipColor(value),
    };
};
